import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';

import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-max-gasket-stress',
    templateUrl: './max-gasket-stress.component.html',
    styleUrls: ['./max-gasket-stress.component.scss'],
    standalone: false
})
export class MaxGasketStressComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form
            .get('maxGasketStress')
            .valueChanges.subscribe((value) =>
                this.form.get('maxGasketStress').patchValue(this.measSvc.format(value, UnitType.DefaultStressUnit), { emitEvent: false })
            );
    }
}
